<template>
  <div class="py-2">
    <div v-if="is_confirmed != true" class="mb-5">
      <h5 class="tail-line-dark mb-3"> 이메일 인증 </h5>
      <p> 
        <b-icon icon="info-circle" />
        이메일을 인증해 주세요. 미인증시 보고서 생성 및 편집이 제한됩니다. 
      </p>

      <b-input-group class="mb-3">
        <b-form-input v-model="confirm_code" placeholder="인증코드를 입력해주세요."
          @keyup.enter="localUserConfirmed()"></b-form-input>
        <b-input-group-append>
          <b-button variant="red" @click="localUserConfirmed()"> 
            {{ is_checking == false ? `인증하기` : `인증중` }} 
            <b-spinner small class="ml-1" v-if="is_checking == true"></b-spinner> 
          </b-button>
        </b-input-group-append>
      </b-input-group>
      
      <div class="text-right f-90 fw-400 gray-600 mb-2">
        인증 코드를 잊으셨나요? <b-button class="ml-2 py-1" size="sm" variant="red-border" :disabled="send_retry == true"
          @click="sendRetry()"> {{ send_retry == true ? '인증코드 재발송 중' : '인증코드 다시받기' }} <b-spinner
            v-if="send_retry == true" class="ml-1" small></b-spinner></b-button>
      </div>
      <div class="text-right f-90 red">
        <fa v-if="local_msg != ''" icon="check-circle" /> {{ local_msg }}
      </div>
    </div>

    <h5 class="tail-line-dark mb-3"> 내 정보 관리 </h5>


    <div v-if="!has_required_info" class="mb-5">
      2024.09.26일자 이후 연락처, 소속 회사명 정보를 받고 있습니다.
    </div>

    <b-row>
      <b-col cols="3">내 계정</b-col>
      <b-col class="py-2">
        {{ e_mail }}
        <div v-if="is_editing" class="mt-2">
          <b-button class="py-1" :variant="update_password != true ? 'teal-border' : 'teal'" @click="updatePassword()">
            {{ update_password != true ? '비밀번호 변경하기' : '비밀번호 변경 취소' }}
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="update_password == true" class="mt-2">
      <b-col cols="3">비밀번호 변경</b-col>
      <b-col class="py-2">
        <b-form>
          <b-input class="mb-1" type="password" v-model="password_old" :class="password_old ? 'bgray-200' : ''"
          placeholder="기존 비밀번호"></b-input>
        <b-input @change="check_validate_password" class="mb-1" type="password" v-model="password_new1" placeholder="새 비밀번호"></b-input>
        <b-input class="mb-1" type="password" v-model="password_new2" placeholder="새 비밀번호 확인"
          :state="check_password && validate_password"></b-input>
        </b-form>

        <div v-if="validate_password === false" class="red f-90"><fa icon="exclamation-circle"/> 최소 8자 및 최대 20자, 하나 이상의 소문자, 숫자, 특수 문자를 모두 포함하여야 합니다.</div>
      </b-col>
    </b-row>
    <!-- <b-tr>
          <b-td>정기결제 정보</b-td>
          <b-td class="py-2">
              <template v-if="is_editing!=true">{{ subscription == true ? "ESG, 지속가능경영 관련 소식 정기결제 중" : "ESG, 지속가능경영 관련 소식 미정기결제" }}</template>
              <template v-else> <b-form-checkbox v-model="local_subscription">ESG, 지속가능경영 관련 소식 정기결제하기</b-form-checkbox> </template>
              </b-td>
          </b-tr> -->

    <b-row class="mt-2">
      <b-col cols="3">이름</b-col>
      <b-col>
        <div v-if="is_editing">
          <b-form-input
            v-model="editable_name"
            placeholder="이름을 입력해주세요"
            class="mb-2"
          />
        </div>
        <div v-else>
          {{ user_name }}
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="3">
        연락처
        <span v-if="!editable_tel" class="red f-90">*</span>
      </b-col>
      <b-col cols="5" class="">
        <div v-if="is_editing" class="">
          <b-form-input 
            class="login-card-input mb-2"
            v-model="editable_tel"
            label="Tel:" 
            placeholder="000-0000-0000" 
          />
        </div>
        <div v-else>
          {{ tel }}
        </div>
      </b-col>
    </b-row>




    <b-row class="mt-2">
      <b-col cols="3">
        소속 회사명
        <span v-if="!editable_company_name" class="red f-90">*</span>
      </b-col>
      <b-col class="">
        <div v-if="is_editing" class="">
          <b-form-input 
            placeholder="소속 회사명"
            v-model="editable_company_name"
          />
        </div>
        <div v-else>
          {{ company_name }}
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="3">
        개인정보제공 동의
        <span v-if="!editable_privacy_agreement_date" class="red f-90">*</span>
      </b-col>
      <b-col class="d-flex align-items-center">
        <b-button @click="showPrivacyPolicy" variant="icon-gray4 f-90 mr-3">개인정보처리방침</b-button>
        <div v-if="is_editing" class="d-flex">
          동의합니다
          <b-form-checkbox v-model="editable_privacy_agreement_date"></b-form-checkbox>
        </div>
        <div v-else>
          <span v-if="privacy_agreement_date">
            {{ privacy_agreement_date }} 에 동의
          </span>
          <span v-else>
            개인정보제공에 동의를 해주세요.
          </span>
        </div>
      </b-col>
    </b-row>



    <b-row v-if="!is_editing && licenseInfo && licenseInfo.available_report_cnt_info" class="mt-2">
      <b-col cols="3">결제 정보</b-col>
      <b-col class="py-2">
        <p>
          올해 {{ licenseInfo.available_report_cnt_info.created_report_cnt }}개의 리포트를 생성하셨습니다.
        </p>
        <template v-if="licenseInfo.isUsed && licenseInfo.is_available">
          <p>
            {{ licenseInfo.subscriptionId }}를 사용중이십니다.
          </p>
          <p v-if="licenseInfo.available_report_cnt_info.code === true">
            현재 리포트 추가 생성이 {{ licenseInfo.available_report_cnt_info.remain_report_cnt }}개 가능합니다.
          </p>
          <p v-else>
            (현재 리포트 추가 생성 불가합니다.)
          </p>
        </template>
        <template v-if="licenseInfo.isUsed && !licenseInfo.is_available">
          해당 라이센스에 대한 결제가 이뤄지지 않았습니다. 결제를 다시 진행하거나 결제 수단을 변경해주세요.
        </template>
      </b-col>
    </b-row>

    <b-button v-if="is_editing != true" variant="teal-border" class="" @click.stop.prevent="is_editing = true"> 
      내 정보 수정하기
    </b-button>
    <div v-else class="mt-5">
      <b-button variant="teal" class="" @click="saveMyInfo()" :disabled="is_saving == true">
        {{ is_saving == true ? '저장중' : '내 정보 저장하기'}} 
        <b-spinner small v-if="is_saving == true"></b-spinner></b-button>
      <b-button class="ml-2" @click="cancleEdit()"> 취소 </b-button>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: "UserInfo",
  data() {
    return {
      is_saving: false,
      is_editing: false,
      update_password: false,
      send_retry: false,
      password_old: '',
      password_new1: '',
      password_new2: '',
      confirm_code: '',
      local_subscription: '',
      local_msg: '',
      is_checking: false,
      editable_company_name: null,
      editable_privacy_agreement_date: null,
      editable_tel: null,
      validate_password: false,
      editable_name: null,
    }
  },
  computed: {
    ...mapState(['user_id', 'e_mail', 'subscription', 'is_confirmed', 'company_name', 'privacy_agreement_date', 'tel', 'user_name',]),
    ...mapState(["licenseInfo"]),
    check_password() {
      if (this.password_new1.length == 0) { return null }
      if (this.password_new1 != this.password_new2) { return false }
      return true
    },

    has_required_info() {
      let tel = this.tel && this.tel.trim() !== '' ? this.tel.trim() : null;
      let company_name = this.company_name && this.company_name.trim() !== '' ? this.company_name.trim() : null;
      return !!(tel && company_name && this.privacy_agreement_date)
    }
  },
  methods: {
    ...mapActions(['saveUserInfo', 'userConfirmed']),
    showPrivacyPolicy() {
      window.open('https://report.qesg.co.kr/terms/privacy_policy', '_blank')
    },
    check_validate_password(password){
        if (password === ""){
            this.validate_password = null;
        } else {
            // 최소 8 자 및 최대 20 자,  하나 이상의 대문자 + 하나의 소문자 + 하나의 숫자 + 하나의 특수 문자 정규식
            const regex = /^(?=.*[a-z])(?=.*[!@#$%^*+=-_])(?=.*[0-9]).{8,20}$/;
            this.validate_password = regex.test(password);
        }
    },
        
    localUserConfirmed() {
      if (this.confirm_code == '' || this.confirm_code == ' ') {
        alert('이메일로 받으신 5자리 인증 코드를 입력해 주세요.')
        return false
      }
      if (this.confirm_code.length != 5) {
        alert('인증 코드는 5자리 입니다. 입력하신 코드를 다시 확인해 주세요.')
        return false
      }
      else {
        this.is_checking = true
        this.userConfirmed({ e_mail: this.e_mail, confirm_code: this.confirm_code })
          .then(response => {
            if (response.data.code === "success") {
              this.$EventBus.$emit('make-toast', '계정 인증 완료', '이메일 계정이 인증되었습니다.')
            } else {
              alert(response.data.msg)
              console.log(response.data.code)
            }
          })
          .catch(error => { 
            error.message = '[계정 인증]' + error.message;
            this.$Sentry.captureException(error);
          })
        this.is_checking = false
      }
    },
    cancleEdit() {
      this.update_password = false;
      this.password_old = '';
      this.password_new1 = '';
      this.password_new2 = '';
      this.local_subscription = this.subscription;
      this.is_editing = false;

      this.editable_privacy_agreement_date = this.privacy_agreement_date ? true : false;

      this.editable_company_name = this.company_name ? this.company_name.trim() : null;
      if (this.editable_company_name === '') this.editable_company_name = null;
      this.editable_tel = this.tel ? this.tel.trim() : null;
      if (this.editable_tel === '') this.editable_tel = null;

    },
    async saveMyInfo() {
      this.is_saving = true
      if (this.update_password != true) {

        if (!this.editable_name || !this.editable_name.trim()) {
          window.alert("이름을 입력해주세요.");
          this.is_saving = false;
          return;
        }

        if (!this.editable_tel || !this.editable_tel.trim()) {
          window.alert("연락처를 입력해주세요.");
          this.is_saving = false;
          
          return;
        }
        if (!this.editable_company_name || !this.editable_company_name.trim()) {
          window.alert("소속 회사명을 입력해주세요.");
          this.is_saving = false;
          
          return;
        }
        if (!this.editable_privacy_agreement_date) {
          window.alert("개인정보제공 동의에 체크해주세요.")
          this.is_saving = false
          
          return;
        }


        this.editable_tel = this.editable_tel.trim();
        this.editable_company_name = this.editable_company_name.trim();

        try {
          const response = await this.saveUserInfo({
          user_id: this.user_id,
          subscription: this.local_subscription,
          user_name: this.editable_name.trim(),
          tel: this.editable_tel,
          company_name: this.editable_company_name,
          privacy_agreement_date: this.editable_privacy_agreement_date
        })

        if (response) {
          if (response.data.code === 'success') {
            this.$EventBus.$emit('make-toast', '내 정보 수정', '계정 정보가 업데이트 되었습니다.')
            this.$emit("updateRequiredInfoFlag", true)
            this.cancleEdit()
          }
          else {
            this.is_saving = false;
            this.$EventBus.$emit(
              'make-toast',
              '저장 실패',
              '오류가 발생했습니다. 다시 한번 시도해 주세요.',
              false,
              'danger'
            );
          
          }
        }
        } catch (error) {
          this.is_saving = false;
          this.$EventBus.$emit(
            'make-toast',
            '저장 실패',
            '기본 정보를 저장하는 중 오류가 발생했습니다.',
            false,
            'danger'
          );
          error.message = '[기본정보 저장]' + error.message;
          this.$Sentry.captureException(error);
        }
      } else {
        if (this.checkForm() == true) {
          const response = await this.saveUserInfo({
            user_id: this.user_id,
            password_old: this.password_old,
            password_new: this.password_new1,
            subscription: this.local_subscription,
            user_name: this.editable_name.trim(),
            tel: this.editable_tel,
            company_name: this.editable_company_name,
            privacy_agreement_date: this.editable_privacy_agreement_date

          })
          if (response) {
            if (response.data.code != 'success') {
              alert('기존 비밀번호가 일치하지 않습니다. 비밀번호를 다시 확인해 주세요.')
            } else {
              this.$EventBus.$emit('make-toast', '내 정보 수정', '계정 정보가 업데이트 되었습니다.')
              this.cancleEdit()
            }

          }
        }
      }
      this.is_saving = false
    },
    sendRetry() {
      this.send_retry = true
      this.requestConfirm()
      this.local_msg = '인증번호를 발송하였습니다. 이메일을 확인해주세요.'
      this.send_retry = false
    },
    updatePassword() {
      if (this.update_password == true) {
        this.update_password = false
      } else {
        this.update_password = true
      }
    },
    requestConfirm() {
      const path = this.$store.state.backend_host + '/request_confirm'

      let formData = new FormData()
      formData.append('e_mail', this.e_mail)
      return axios.post(path, formData)
    },
    checkForm() {
      if (this.password_old == '') {
        alert('기존 비밀번호를 입력해주세요.')
        return false
      }
      else if (this.password_new1 == '') {
        alert('새 비밀번호를 입력해주세요.')
        return false
      }
      else if (this.password_new2 == '') {
        alert('새 비밀번호 확인을 입력해주세요.')
        return false
      }
      if (!this.validate_password) {
        alert('새 비밀번호가 유효하지 않습니다. 조건을 확인해주세요.');
        return false;
      }
      if (!this.check_password) {
        alert('새 비밀번호와 확인이 일치하지 않습니다.');
        return false;
      }
      else return true
    }
  },
  created() {
    if (!this.has_required_info) {
      this.is_editing = true
    }

    this.editable_privacy_agreement_date = this.privacy_agreement_date ? true : false;

    this.editable_company_name = this.company_name ? this.company_name.trim() : null;
    if (this.editable_company_name === '') this.editable_company_name = null
    this.editable_tel = this.tel ? this.tel.trim() : null;
    if (this.editable_tel === '') this.editable_tel = null;

    this.local_subscription = this.subscription;
    this.editable_name = this.user_name ? this.user_name.trim() : null;
  },
}
</script>

<style></style>